import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectCoverflow, EffectCards } from 'swiper/modules';

Swiper.use([Navigation, Pagination, Autoplay, EffectCoverflow, EffectCards]);

document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.swiper-slider').forEach(function(slider) {

        let defaults = {
            effect: 'slide',
            autoplay: {delay: 5000},
            keyboard: true,
            loop: true,
            navigation: {
                enabled: false,
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: '.swiper-pagination-progressbar-fill',
                clickable: false,
                type: 'progressbar',
            },
        };

        let options = Object.assign({}, defaults, JSON.parse(slider.dataset.options || '{}'));
        // console.log(options)
        new Swiper(slider, options);
    });

     var swiper = new Swiper('.postsslider-container', {
        autoplay: false,
        slidesPerView: 1,
        spaceBetween: 15,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        pagination: false,
        breakpoints: {
            // when window width is >= 320px
            768: {
              slidesPerView: 2,
            },
            // when window width is >= 480px
            990: {
              slidesPerView: 3,
            }
          }
      });


    var swiper = new Swiper('.swiper-container', {
        effect: 'slide',
        autoplay: {delay: 5000},
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          type: 'progressbar',
        },
        navigation: false
      });

    var svw = jQuery('.swiper.tarifswiper').attr('data-swiper-slidesperview');

    const swipertarif = new Swiper(".tarifswiper", {
      // effect: "cards",
      initialSlide: 0,
      grabCursor: false,
      allowTouchMove: false,
      centeredSlides: true,
      centerInsufficientSlides: true,
      centeredSlidesBounds: false,
      slidesPerView: svw,
      loop: true,

      on: {
        reachEnd: function (ev) {
            console.log(ev);
        },
    click: function (ev) {
        if (!jQuery(ev.clickedSlide).hasClass('swiper-slide-active')) {
            var slidto = ev.clickedSlide.getAttribute('data-slideto');
            // if (this.clickedIndex > 2) {
            //     slidto = parseInt(slidto)-1;
            // }
            console.log("=="+slidto);
            ev.slideToLoop(slidto);
        }
        // console.log(this.clickedSlide.getAttribute('data-swiper-slide-index'));
        // console.log(this.clickedIndex, this.realIndex);
    },
  }
      // slideToClickedSlide: true,

    // loopAdditionalSlides: 100,
      // cardsEffect: {
      //   perSlideOffset: 100,
      //   rotate: false
      //   },
      // pagination: {
      //   el: ".swiper-pagination",
      //   clickable: true,
      // },
      // navigation: false
    });

     // effect: "coverflow",
     //  grabCursor: true,
     //  centeredSlides: true,
     //  slidesPerView: "auto",
     //  loop: true,
     //  coverflowEffect: {
     //    rotate: 50,
     //    stretch: 0,
     //    depth: 100,
     //    modifier: 1,
     //    slideShadows: true,
     //  },

    console.log("===tarif====");
});
